import { checkout } from './checkout.fr';
import { cookies } from './cookies.fr';
import { footer } from './footer';
import { notifications } from './notifications.fr';
import { register } from './register.fr';
import { login } from './login.fr';
import { orderDetails } from './order-details.fr';
import { actions } from './actions.fr';
import { repairAnalysisInfo } from './repairAnalysisInfo.fr';
import { welcomeJomatik } from './welcome-jomatik.fr';
import { discount } from './discount.fr';
import { navigation } from './navigation.fr';

export const fr = {
    checkout,
    cookies,
    footer,
    notifications,
    register,
    login,
    orderDetails,
    actions,
    repairAnalysisInfo,
    welcomeJomatik,
    discount,
    navigation,
};
